/**
 * Log sanitization — strips sensitive data before logging.
 *
 * Never logs: passwords, tokens, secrets, reset links, API keys.
 * Recursively sanitizes objects so nested fields are scrubbed.
 */

const SENSITIVE_KEYS = /^(password|passwd|token|secret|api[_-]?key|authorization|reset[_-]?link|session[_-]?token|access[_-]?token|refresh[_-]?token)$/i;

export function sanitizeValue(value: unknown): unknown {
  if (value === null || value === undefined) return value;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (Array.isArray(value)) return value.map(sanitizeValue);
  if (typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(value as Record<string, unknown>)) {
      if (SENSITIVE_KEYS.test(key)) {
        result[key] = '[REDACTED]';
      } else {
        result[key] = sanitizeValue((value as Record<string, unknown>)[key]);
      }
    }
    return result;
  }
  return value;
}

export function sanitizeContext(context: Record<string, unknown>): Record<string, unknown> {
  return sanitizeValue(context) as Record<string, unknown>;
}
